// extracted by mini-css-extract-plugin
module.exports = {"circle":"getting-started-completed_circle__23R9N","anim":"getting-started-completed_anim__2P_ik"};